// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"30d9bbc4","375":"6c776dfc","440":"d5c8424d","535":"b9523b6e","653":"1776040b","662":"58d7f0f4","690":"455127f7","704":"1265ef42","794":"ba546328"}[chunkId] + ".chunk.js";
};